module.exports = __webpack_public_path__ + "static/media/play.4d9689a7.svg";